import { usePage } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import { SignupForm } from "@/components/forms/signup-form";
import AuthLayout from "@/layouts/auth_layout";
import type { SharedData } from "@/types";

export default function SignupPage() {
  const { t } = useTranslation();
  const { invitation } = usePage<
    SharedData & {
      invitation?: {
        code: string;
        email_address: string;
        account?: { name: string };
      };
    }
  >().props;

  return (
    <AuthLayout
      headingInContent
      title={t("auth.signup_title")}
      description={t("auth.signup_description")}
    >
      <SignupForm invitation={invitation} />
    </AuthLayout>
  );
}
